import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const HeroLines = ({ lines, className = "", testId }) => (
  <h1 className={className} data-testid={testId}>
    {lines.map((line, i) => (
      <span key={i} className="block pb-[0.12em]">{line}</span>
    ))}
  </h1>
);
